<template>
  <div>
    <slot name="title" />
    <v-tabs v-model="tab" slider-color="primary" class="tabs">
      <v-tab
        v-for="tab in tabs"
        :key="tab.id"
        :ripple="false"
        class="tabs__item"
        @click="onTabClick(tab.name)"
      >
        {{ tab.text }}
      </v-tab>

      <div class="comparison-data">
        <div v-if="selectedDate">
          {{ $t("message.reviews.categories.selectedPeriod") }}:
          <b>{{ baseDateRange }}</b>
        </div>
        <div v-if="comparisonDate" class="comparison-data__el--small">
          {{ $t("message.reviews.categories.comparedPeriod") }}:
          <b>{{ comparisonDateRange }}</b>
        </div>
      </div>
    </v-tabs>
    <v-tabs-items v-model="tab" class="tabs__content">
      <v-tab-item v-for="tab in tabs" :key="tab.id">
        <slot :name="tab.name" />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import { GTM_EVENT_NAME } from "@/enums/gtm-events";
import { mapState } from "vuex";

export default {
  name: "ReviewsCategoriesTabs",
  props: {
    tabs: {
      type: Array,
      required: true
    },
    contentType: {
      type: String,
      default: "table"
    }
  },
  data() {
    return {
      tab: null
    };
  },
  computed: {
    ...mapState("reviewsCategoriesAnalytics", [
      "selectedDate",
      "comparisonDate"
    ]),
    isComparisonDate() {
      return !!Object.keys(this.comparisonDate).length;
    },
    baseDateRange() {
      return `${this.selectedDate.date_from} - ${this.selectedDate.date_to}`;
    },
    comparisonDateRange() {
      return `${this.comparisonDate.date_from} - ${this.comparisonDate.date_to}`;
    }
  },

  methods: {
    onTabClick(type) {
      if (this.$route.name === "reviews-category-details") {
        if (this.contentType === "table") {
          this.$gtm.trackCustomEvent({
            event:
              GTM_EVENT_NAME.REVIEW_CATEGORY_ANALYTICS_DETAILS_TABLE_TYPE_CHANGE,
            type
          });
        } else if (this.contentType === "chart") {
          this.$gtm.trackCustomEvent({
            event:
              GTM_EVENT_NAME.REVIEW_CATEGORY_ANALYTICS_DETAILS_CHART_TYPE_CHANGE,
            type
          });
        }
      } else if (this.$route.name === "reviews-categories") {
        if (this.contentType === "table") {
          this.$gtm.trackCustomEvent({
            event:
              GTM_EVENT_NAME.REVIEW_CATEGORY_ANALYTICS_OVERVIEW_TABLE_TYPE_CHANGE,
            type
          });
        }
      }
    },
    resetTabIndex() {
      this.tab = null;
    }
  }
};
</script>

<style lang="scss" scoped>
.tabs {
  position: relative;
  z-index: 1;
  margin-top: $spacing * 2.5;

  ::v-deep * {
    overflow: visible !important;
  }

  ::v-deep .v-tabs-bar {
    background: transparent;
  }

  ::v-deep .v-tabs-slider-wrapper {
    display: none;
  }

  ::v-deep .v-slide-group__wrapper {
    contain: unset;
  }

  &__filters {
    display: flex;
    justify-content: flex-end;
    padding: 0 $spacing * 2;
    margin-bottom: $spacing * 3;
    margin-top: $spacing;
    gap: $spacing;
  }

  &__item {
    text-transform: unset;
    letter-spacing: unset;
    @include font-size(18px);
    font-weight: 600;
    padding: $spacing * 1.5 $spacing * 3;
    background: $gray-800;
    border-radius: 8px 8px 0 0;
    &:before {
      border-radius: 8px 8px 0 0;
    }
    &:not(.v-tab--active) {
      color: $grey-darker !important;
      background: $gray-200 !important;
    }
    &.v-tab--active {
      background: white;
      overflow: hidden;
      &:before {
        display: none;
      }
      &:after {
        border-radius: 8px 8px 0 0;
        content: "";
        display: block;
        width: 100%;
        height: 100%;
        box-shadow: 0px -10px 20px rgba(54, 60, 86, 0.07);
        position: absolute;
        z-index: -1;
      }
    }
  }

  &__content {
    padding: $spacing * 2;
    box-shadow: 0px 0px 30px rgba(54, 60, 86, 0.07);
    border-radius: 0 24px 24px 24px;
    min-height: 530px;
  }
}
.comparison-data {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  align-items: flex-end;
  margin-top: -$spacing;

  &__el {
    &--small {
      margin-top: $spacing * 0.75;
      color: black;
      font-size: 12px;
    }
  }
}
</style>
